<template>
    <v-dialog v-model="isActive" class="rounded-0" width="430" scrollable transition="dialog-top-transition"
        @click:outside="confirmAndClose(false)">
        <v-card class="rounded-0">
            <v-card flat class="rounded-0">
                <v-app-bar flat color="white" height="50" class="ma-2">
                    <v-btn icon @click="confirmAndClose(false)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title class="pr-1 text-h6 font-weight-bold primary--text"
                        style="white-space: normal; word-break: break-word;">Mi turno</v-toolbar-title>
                </v-app-bar>
            </v-card>
            <v-card-text class="d-flex flex-column align-center">
                <TurnoCard title=" Mi turno" />
            </v-card-text>
            <div class="d-flex flex-column align-center justify-center pa-3">
                <v-btn class="pa-5" elevation="0" width="200" color="primary" @click="confirmAndClose(true)"
                    :loading="loading">
                    SI, CONFIRMAR
                </v-btn>
                <v-btn class="pa-5 mt-1" outlined color="secondary" width="200" @click="confirmAndClose(false)">
                    NO, MODIFICAR
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import TurnoCard from '@/components/cards/TurnoCard.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['titulo', 'width'],
    components: {
        TurnoCard,
    },
    data() {
        return {
            isActive: false,
            loading: false,
            callback: null,
        }
    },
    computed: {
        ...mapGetters('turnos', ['tmpTurno', 'nuevoTurno', 'turnosActivos']),
    },
    methods: {
        ...mapActions('turnos', ['getDistritos', 'getDireDistri', 'getHorarios', 'solicitarTurno', 'guardarTurnoTmp']),
        /*         solicitarNuevoTurno() {
                    this.loading = true
                    this.solicitarTurno().then(() => {
                        this.cerrarDialogo()
                        this.$emit('closeFormNuevoTurnos')
                        //this.$router.push('/dashboard')
                    }).finally(() => {
                        this.loading = false
                    })
                },
        
                descartarTurnoTmp() {
                    this.guardarTurnoTmp({})
                    this.cerrarDialogo()
                }, */
        confirmAndClose(result) {
            this.loading = true
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.loading = false
            this.isActive = false
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
    }
}

</script>